import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function getRepairExtraList(data) {
  return await getAPIResponse('/v1/repair-extras', data);
}
